"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateUserTypeBodyToJSON = exports.UpdateUserTypeBodyFromJSONTyped = exports.UpdateUserTypeBodyFromJSON = void 0;
var _1 = require("./");
function UpdateUserTypeBodyFromJSON(json) {
    return UpdateUserTypeBodyFromJSONTyped(json, false);
}
exports.UpdateUserTypeBodyFromJSON = UpdateUserTypeBodyFromJSON;
function UpdateUserTypeBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': (0, _1.UserTypeFromJSON)(json['type']),
    };
}
exports.UpdateUserTypeBodyFromJSONTyped = UpdateUserTypeBodyFromJSONTyped;
function UpdateUserTypeBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': (0, _1.UserTypeToJSON)(value.type),
    };
}
exports.UpdateUserTypeBodyToJSON = UpdateUserTypeBodyToJSON;
